import React from 'react'
import Home from './components/Home/Home'
import Products from './components/Product/Products';
import Login from './components/User/Login';
import Register from './components/User/Register';
import ProductDetail from './components/Product/ProductDetail';
import Blogs from './components/Blog/Blogs';
import BlogItem from './components/Blog/BlogItem';
import Comment from './components/Comment/Comment';
import Contact from './components/Contact/Contact';
import Order from './components/Order/Order';
import OrderDetail from './components/Order/OrderDetail';
import ProductAdmin from './components/Product/ProductAdmin';

const routes = [
    {
        path: '/',
        exact: true,
        main: () => <Home />
    },
    {
        path: '/products',
        exact: true,
        main: () => <Products />
    },
    {
        path: '/products/:id',
        exact: false,
        main: ({ match, history }) => <ProductDetail history={history} match={match} />
    },
    {
        path: '/product/add',
        exact: false,
        main: ({ history }) => <ProductAdmin history={history} />
    },
    {
        path: '/product/:id/edit',
        exact: false,
        main: ({ match, history }) => <ProductAdmin history={history} match={match} />
    },
    {
        path: '/orders',
        exact: true,
        main: () => <Order />
    },
    {
        path: '/orders/:id',
        exact: false,
        main: ({ match, history }) => <OrderDetail history={history} match={match} />
    },
    {
        path: '/blogs',
        exact: true,
        main: () => <Blogs />
    },
    {
        path: '/blogs/:id',
        exact: false,
        main: ({ match, history }) => <BlogItem history={history} match={match} />
    },
    {
        path: '/comments',
        exact: false,
        main: () => <Comment />
    },
    {
        path: '/contact',
        exact: false,
        main: () => <Contact />
    },
    {
        path: '/login',
        exact: false,
        main: ({ history }) => <Login history={history} />
    },
    {
        path: '/register',
        exact: false,
        main: ({ history }) => <Register history={history} />
    },
]

export default routes;